import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { SimpleModal } from '@sequencehq/core-components'
import { useNotifications } from '@sequencehq/core-components'

export const DeleteCreditGrantModal = (props: {
  trigger: React.ReactElement
  creditGrantId: string
  creditGrantName: string
  onClose?: () => void
}) => {
  const { displayNotification } = useNotifications()
  const deleteCreditGrantMutation = useMutation(
    dashboard20240730Client.deleteCreditGrant,
    {
      onSuccess: () => {
        displayNotification(`${props.creditGrantName} deleted`, {
          type: 'success'
        })
      }
    }
  )

  return (
    <SimpleModal
      trigger={props.trigger}
      variant="dialog"
      title="Delete credit grant"
      onClose={() => props.onClose?.()}
      submitButtonText="Delete"
      submittingButtonText="Deleting..."
      onSubmit={async () => {
        const res = await deleteCreditGrantMutation.mutateAsync({
          id: props.creditGrantId
        })
        return Boolean(res)
      }}
      isDestructive
      data-testid="deleteCreditGrant.modal"
    >
      This will remove the credit grant and any remaining balance from the
      customer's account. This action cannot be undone.
    </SimpleModal>
  )
}
